import { useEffect } from 'react';

import { Screen } from '@tempmee/react';
import { BackButton } from '~/commonComponents';
import { Content } from './components/Content';
import { Title } from './components/Title';

export function WorkerClassification({ isRegistration }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />} title="Worker Type Setting">
        <Title isRegistration={isRegistration} showHeading={false} />
      </Screen.Header>
      <Screen.Body>
        <Content isRegistration={isRegistration} />
      </Screen.Body>
    </Screen>
  );
}
